import React, { useEffect, useState } from "react";
import { Nav, Collapse } from "react-bootstrap";
import {
  FaShoppingCart,
  FaCalendarAlt,
  FaUser,
  FaTasks,
  FaWpforms,
  FaTable,
  FaFileAlt,
  FaComments,
  FaHeadset,
  FaEnvelope,
  FaChevronDown,
  FaList,
  FaTags,
  FaClipboardList,
} from "react-icons/fa";
import "./index.scss";
import logo from "../../../assets/images/logoF.png";
import logo1 from "../../../assets/images/logo-a.png";
import { Link, useLocation } from "react-router-dom";

export default function Sidebar({ collapsed, mobileOpen, onClose }) {
  const [openMenu, setOpenMenu] = useState(null);
  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(location.pathname);

  useEffect(() => {
    setActiveMenu(location.pathname);
  }, [location]);

  return (
    <div
      className={`sidebar d-flex flex-column p-3 
        ${collapsed ? "collapsed" : ""} 
        ${mobileOpen ? "open" : ""}  // 👈 ajoute la classe mobile
      `}>
      {/* Logo */}
      {!mobileOpen && (
        <div className="sidebar-logo mb-4 d-flex align-items-center">
          <div>
            <img src={logo1} alt="logo-mini" />
          </div>
          {!collapsed && (
            <span className="logo-text ms-2">
              <img src={logo} alt="logo-full" />
            </span>
          )}
        </div>
      )}

      {/* Menu */}
      <div className="sidebar-section">
        {!collapsed && <span className="section-title">MENU</span>}
        <Nav className="flex-column">
          {/* Dashboard */}
          <Nav.Item>
            <Nav.Link
              onClick={() => toggleMenu("dashboard")}
              className={`d-flex justify-content-between align-items-center ${
                activeMenu === "/dashboard" ? "active" : ""
              }`}>
              <Link to={"/dashboard"}>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M5.5 3.25C4.25736 3.25 3.25 4.25736 3.25 5.5V8.99998C3.25 10.2426 4.25736 11.25 5.5 11.25H9C10.2426 11.25 11.25 10.2426 11.25 8.99998V5.5C11.25 4.25736 10.2426 3.25 9 3.25H5.5ZM4.75 5.5C4.75 5.08579 5.08579 4.75 5.5 4.75H9C9.41421 4.75 9.75 5.08579 9.75 5.5V8.99998C9.75 9.41419 9.41421 9.74998 9 9.74998H5.5C5.08579 9.74998 4.75 9.41419 4.75 8.99998V5.5ZM5.5 12.75C4.25736 12.75 3.25 13.7574 3.25 15V18.5C3.25 19.7426 4.25736 20.75 5.5 20.75H9C10.2426 20.75 11.25 19.7427 11.25 18.5V15C11.25 13.7574 10.2426 12.75 9 12.75H5.5ZM4.75 15C4.75 14.5858 5.08579 14.25 5.5 14.25H9C9.41421 14.25 9.75 14.5858 9.75 15V18.5C9.75 18.9142 9.41421 19.25 9 19.25H5.5C5.08579 19.25 4.75 18.9142 4.75 18.5V15ZM12.75 5.5C12.75 4.25736 13.7574 3.25 15 3.25H18.5C19.7426 3.25 20.75 4.25736 20.75 5.5V8.99998C20.75 10.2426 19.7426 11.25 18.5 11.25H15C13.7574 11.25 12.75 10.2426 12.75 8.99998V5.5ZM15 4.75C14.5858 4.75 14.25 5.08579 14.25 5.5V8.99998C14.25 9.41419 14.5858 9.74998 15 9.74998H18.5C18.9142 9.74998 19.25 9.41419 19.25 8.99998V5.5C19.25 5.08579 18.9142 4.75 18.5 4.75H15ZM15 12.75C13.7574 12.75 12.75 13.7574 12.75 15V18.5C12.75 19.7426 13.7574 20.75 15 20.75H18.5C19.7426 20.75 20.75 19.7427 20.75 18.5V15C20.75 13.7574 19.7426 12.75 18.5 12.75H15ZM14.25 15C14.25 14.5858 14.5858 14.25 15 14.25H18.5C18.9142 14.25 19.25 14.5858 19.25 15V18.5C19.25 18.9142 18.9142 19.25 18.5 19.25H15C14.5858 19.25 14.25 18.9142 14.25 18.5V15Z"
                      fill="#667085"
                    />
                  </svg>
                  {!collapsed && "Dashboard"}
                </div>
              </Link>
              {!collapsed && <FaChevronDown size={12} />}
            </Nav.Link>
            {!collapsed && (
              <Collapse in={openMenu === "dashboard"}>
                <div className="submenu ps-4">
                  <Nav.Link>Overview</Nav.Link>
                  <Nav.Link>Analytics</Nav.Link>
                </div>
              </Collapse>
            )}
          </Nav.Item>

          {/* Users Management */}
          <Nav.Item>
            <Nav.Link
              className={`d-flex justify-content-between align-items-center ${
                activeMenu === "/users" ? "active" : ""
              }`}>
              <Link to={"/users"}>
                <div>
                  <FaUser size={20} />
                  {!collapsed && "Utilisateurs"}
                </div>
              </Link>
            </Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link
              className={`d-flex justify-content-between align-items-center ${
                activeMenu === "/image-category" ? "active" : ""
              }`}>
              <Link to={"/image-category"}>
                <div>
                  <FaList size={20} />
                  {!collapsed && "Image Categories"}
                </div>
              </Link>
            </Nav.Link>
          </Nav.Item>
          {/* Products Management */}
          <Nav.Item>
            <Nav.Link
              onClick={() => toggleMenu("products")}
              className={`d-flex justify-content-between align-items-center ${
                activeMenu === "/products" ? "active" : ""
              }`}>
              <Link to={"/products"}>
                <div>
                  <FaShoppingCart size={20} />
                  {!collapsed && "Produits"}
                </div>
              </Link>
              {!collapsed && <FaChevronDown size={12} />}
            </Nav.Link>
            {!collapsed && (
              <Collapse in={openMenu === "products"}>
                <div className="submenu ps-4">
                  <Nav.Link as={Link} to="/products">
                    Liste des Produits
                  </Nav.Link>
                  <Nav.Link as={Link} to="/add-product">
                    Ajouter un Produit
                  </Nav.Link>
                </div>
              </Collapse>
            )}
          </Nav.Item>

          {/* Categories Management */}
          <Nav.Item>
            <Nav.Link
              className={`d-flex justify-content-between align-items-center ${
                activeMenu === "/category" ? "active" : ""
              }`}>
              <Link to={"/category"}>
                <div>
                  <FaTable size={20} />
                  {!collapsed && "Catégories"}
                </div>
              </Link>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              className={`d-flex justify-content-between align-items-center ${
                activeMenu === "/promo" ? "active" : ""
              }`}>
              <Link to={"/promo"}>
                <div>
                  <FaTags size={20} />
                  {!collapsed && "Code promo"}
                </div>
              </Link>
            </Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link
              className={`d-flex justify-content-between align-items-center ${
                activeMenu === "/orders" ? "active" : ""
              }`}>
              <Link to={"/orders"}>
                <div>
                  <FaClipboardList size={20} />
                  {!collapsed && "Commandes"}
                </div>
              </Link>
            </Nav.Link>
          </Nav.Item>
          {/* Contacts Management */}
          <Nav.Item>
            <Nav.Link
              className={`d-flex justify-content-between align-items-center ${
                activeMenu === "/contacts" ? "active" : ""
              }`}>
              <Link to={"/contacts"}>
                <div>
                  <FaComments size={20} />
                  {!collapsed && "Contacts"}
                </div>
              </Link>
            </Nav.Link>
          </Nav.Item>

          {/* Newsletter Management */}
          <Nav.Item>
            <Nav.Link
              className={`d-flex justify-content-between align-items-center ${
                activeMenu === "/newsletters" ? "active" : ""
              }`}>
              <Link to={"/newsletters"}>
                <div>
                  <FaEnvelope size={20} />
                  {!collapsed && "Newsletters"}
                </div>
              </Link>
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </div>
    </div>
  );
}
